import { render } from "./ViewData.vue?vue&type=template&id=2129d6ce&ts=true"
import script from "./ViewData.vue?vue&type=script&lang=ts"
export * from "./ViewData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__